import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { addBreadcrumb } from "@/lib/sentry";

/**
 * Records SPA route changes as Sentry breadcrumbs so error reports include
 * the navigation trail leading up to the failure. Mounted inside <BrowserRouter>.
 */
export function SentryRouteTracker() {
  const location = useLocation();

  useEffect(() => {
    addBreadcrumb({
      category: "navigation",
      message: location.pathname,
      data: location.search ? { search: location.search } : undefined,
    });
  }, [location.pathname, location.search]);

  return null;
}
